// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"34":"71d9afa2","78":"7979a142","284":"f2535bb7","435":"d94b043e","486":"2b24a430","518":"4723dace","541":"11fb67bb","606":"8a1ed1b0","694":"f07aafd1","787":"b1188ee2","796":"7def2bae","821":"ff54ac29","969":"a95a3140"}[chunkId] + ".js";
};